(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/frejaeid/components/frejaeid-start.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/frejaeid/components/frejaeid-start.js');

'use strict';

const Button = svs.ui.ReactButton;
const Bank = svs.ui.ReactBank;
const route = svs.playerLoginReact.constants.route;
const _svs$playerLoginReact = svs.playerLoginReact.sharedComponents,
  useUrlHelper = _svs$playerLoginReact.useUrlHelper,
  SelectEidMenu = _svs$playerLoginReact.SelectEidMenu;

const FrejaeIdStart = _ref => {
  let _ref$isLogin = _ref.isLogin,
    isLogin = _ref$isLogin === void 0 ? true : _ref$isLogin;
  const history = ReactRouterDOM.useHistory();
  const _useUrlHelper = useUrlHelper(),
    navigateToCancelUrl = _useUrlHelper.navigateToCancelUrl;
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);
  const onFrejaeIdThisDeviceClick = () => {
    if (isLogin) {
      history.push(route.LOGIN_FREJAEID_POLL_APP_ROUTE);
    } else {
      history.push(route.REGISTRATE_FREJAEID_POLL_APP_ROUTE);
    }
  };
  const onnavigateToCancelUrl = () => {
    navigateToCancelUrl();
  };

  React.useLayoutEffect(() => {
    if (!isStandardMobile) {
      if (isLogin) {
        history.push(route.LOGIN_FREJAEID_POLL_QR_ROUTE);
      } else {
        history.push(route.REGISTRATE_FREJAEID_POLL_QR_ROUTE);
      }
    }
  }, [history, isLogin, isStandardMobile]);
  return React.createElement(React.Fragment, null, isStandardMobile && React.createElement(React.Fragment, null, React.createElement(SelectEidMenu, {
    isLogin: isLogin
  }), React.createElement(Button, {
    block: true,
    iconPosition: "left",
    inverted: true,
    onClick: onFrejaeIdThisDeviceClick,
    size: 300
  }, React.createElement(Bank, {
    className: "align-left animate animate-show animate-time-short",
    name: "freja-eid-vertical-neg",
    size: 24
  }), React.createElement("span", {
    className: "animate animate-show animate-time-short"
  }, isLogin ? 'Logga in' : 'Bli kund')), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement(Button, {
    block: true,
    onClick: onnavigateToCancelUrl,
    size: 300,
    transparent: true
  }, "Avbryt"))), !isStandardMobile && null);
};
svs.playerLoginReact.frejaeid.components.FrejaeIdStart = FrejaeIdStart;

 })(window);